<script>
import { markOnboardingChannelReturn } from 'dashboard/helper/onboardingChannelReturn';

export default {
  name: 'OnboardingChannelInfoModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    channelName: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    subPage: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    handleConnectNow() {
      const accountId = this.$route.params.accountId;
      markOnboardingChannelReturn(accountId);
      this.$router.push({
        name: 'settings_inboxes_page_channel',
        params: {
          accountId,
          sub_page: this.subPage,
        },
      });
    },
  },
};
</script>

<template>
  <woot-modal :show="show" :on-close="handleClose">
    <woot-modal-header
      :header-title="channelName"
      :header-content="description"
    />
    <div class="flex flex-col gap-2 px-8 pb-8 pt-4">
      <woot-button class="w-full justify-center" @click="handleConnectNow">
        {{ $t('ONBOARDING_SHELL.STEPS.CHANNEL.CONNECT_NOW') }}
      </woot-button>
    </div>
  </woot-modal>
</template>
